import { getBACColorClass, getBACStatus } from '@/utils/bac'

interface BACCardProps {
  currentBAC: number
  currentSessionDrinks: number
}

export default function BACCard({ currentBAC, currentSessionDrinks }: BACCardProps) {
  const colorClass = getBACColorClass(currentBAC)
  const status = getBACStatus(currentBAC)

  return (
    <div className={`card ${colorClass} transition-colors duration-500 min-w-[140px] flex-shrink-0 snap-start md:min-w-0 md:flex-shrink`} role="status" aria-label={`Current BAC: ${currentBAC.toFixed(3)}%, status: ${status}`}>
      <div className="flex items-center justify-between whitespace-nowrap gap-12 md:gap-4">
        <div>
          <p className="text-sm opacity-80 mb-1">Current BAC</p>
          <p className="text-4xl font-bold font-mono" aria-live="polite">
            {currentBAC.toFixed(3)}%
          </p>
          <p className="text-sm opacity-80 mt-1">{status}</p>
        </div>

        <div className="text-center">
          <p className="text-sm opacity-80 mb-1">This Session</p>
          <p className="text-3xl font-bold">
            {currentSessionDrinks}
          </p>
          <p className="text-sm opacity-80 mt-1">
            drink{currentSessionDrinks !== 1 ? 's' : ''}
          </p>
        </div>
      </div>
    </div>
  )
}
